/* Quote Intro Block JS File */
$(document).ready(function() {

});
